import React, {FC} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight, faPlus} from "@fortawesome/free-solid-svg-icons";
import {useApi} from "../api/APIContext";
import {useThemes} from "../planning/util/theming";
import {AddOrEditQuantityTypeModal} from "../modals/AddOrEditQuantityTypeModal";
import { useModal } from "@traas/lib/src/components/layout/ModalProvider";
import { Button } from "@traas/lib/src/components/form/Button";
import {faSquareCheck} from "@fortawesome/free-regular-svg-icons";
import {useNavigate} from "react-router";

export const TaskTypesCard: FC<{}> = props => {
  const {quantityTypes} = useApi()
  const {getTheme} = useThemes()
  const navigate = useNavigate()

  const addModal = useModal({title: "Type toevoegen", body: <AddOrEditQuantityTypeModal />})

  return <div>
    <div className={'flex items-end justify-between mb-6'}>
      <h2 className={'font-medium text-xl'}>Taak types</h2>
      <Button type={'primary'} size={'md'} onClick={() => addModal.open()} text={'Toevoegen'} icon={faPlus} />
    </div>
    <div className={'bg-white shadow-xs rounded-lg overflow-hidden mb-6'}>
      <table className={'w-full'}>
        <tbody>
        {quantityTypes.sort((a,b) => (+a.enabled) - (+b.enabled)).map((qt, i) => {
          const defaultColor = qt.defaultColor ? getTheme(qt.defaultColor) : null
          return <tr key={i} className={`h-10 ${i !== 0 ? 'border-t border-slate-100' : ''} hover:bg-blue-50 cursor-pointer text-sm`} onClick={() => navigate('/kleuren/' + qt.id)}>
            <td className={'px-4 border-r border-slate-100 font-medium'}>{qt.name}</td>
            <td className={'px-4 border-r border-slate-100'}>
              {defaultColor && <div className={'flex items-center'}>
                <div className={`h-4 w-4 rounded-full ${defaultColor.bg} mr-2`}></div>
                {defaultColor.name}
              </div>}
            </td>
            <td className={'px-4 border-r border-slate-100'}><FontAwesomeIcon icon={faSquareCheck} className={'text-slate-500 mr-1'} />{qt.descriptionTemplate.length} Taak {qt.descriptionTemplate.length === 1 ? 'sjabloon' : 'sjablonen'}</td>
            <td className={'px-4 text-right'}><span className={'text-sm uppercase text-blue-800'}>Bewerken</span> <FontAwesomeIcon icon={faChevronRight} className={'text-blue-700 text-sm ml-1'} /></td>
          </tr>
        })}
        </tbody>
      </table>
    </div>
  </div>
}
